import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { service, factories, models } from 'powerbi-client';

import { PowerBIService } from '../../../../service/proxy';
import { ToastService } from '../../../shared/toast/toast.service';
import { ErrorService } from '../../../shared/services/error-service';

@Component({
    selector: 'app-power-bi-report',
    templateUrl: './power-bi-report.component.html',
    styleUrls: ['./power-bi-report.component.scss'],
    standalone: true,

    imports: [
        CommonModule,
        FormsModule
    ],

    providers: [
        PowerBIService,
        ToastService,
        ErrorService
    ]
})
export class PowerBiReportComponent implements OnInit, AfterViewInit {
    public loading = true;
    public activeTab = 'Monthly Volume';

    public tabs = [
        'Monthly Volume',
        'Sales Comparison',
        'Risk Appetite',
        'Client Risk Appetite',
        'Insurer Risk Appetite',
        'Days Sales Outstanding'
    ];

    private embedConfig: any;
    private viewReady = false;
    private configReady = false;
    private powerbiClientService?: service.Service;
    private reportRef: any;

    @ViewChild('reportContainer', { static: true }) reportContainer!: ElementRef;

    constructor(
        private powerBIService: PowerBIService,
        private toastService: ToastService,
        private errorService: ErrorService
    ) {}

    ngOnInit(): void {
        this.powerBIService.getReportEmbedConfig().subscribe({
            next: (config: any) => {
                this.embedConfig = {
                    type: 'report',
                    accessToken: config.accessToken,
                    embedUrl: config.embedUrl,
                    id: config.id,
                    tokenType: models.TokenType.Embed,
                    settings: {
                        filterPaneEnabled: false,
                        navContentPaneEnabled: false
                    }
                };

                this.configReady = true;
                this.tryEmbed();
            },
            error: (err: any) => {
                this.loading = false;
                this.toastService.show('Failed to load Power BI report.', 'error');
                this.errorService.handleError(err);
            }
        });
    }

    ngAfterViewInit(): void {
        this.viewReady = true;
        this.tryEmbed();
    }

    private tryEmbed(): void {
        if (this.viewReady && this.configReady && this.reportContainer?.nativeElement) {
            this.powerbiClientService = new service.Service(
                factories.hpmFactory,
                factories.wpmpFactory,
                factories.routerFactory
            );

            this.reportRef = this.powerbiClientService.embed(this.reportContainer.nativeElement, this.embedConfig);

            this.reportRef.on('loaded', () => {
                this.toastService.show('Report loaded successfully.', 'success');
                this.setActivePage(this.activeTab);
                this.loading = false;
            });
        }
    }

    public setActivePage(tabLabel: string): void {
        this.activeTab = tabLabel;

        if (!this.reportRef) {
            return;
        }

        this.reportRef.getPages().then((pages: any[]) => {
            const matchingPage = pages.find((page) =>
                page.displayName.toLowerCase().includes(tabLabel.toLowerCase())
            );

            if (matchingPage) {
                matchingPage.setActive();
            }
            else {
                this.toastService.show(`Tab "${tabLabel}" not found in report.`, 'warning');
            }
        });
    }
}
